import IMAGES_CDN_PATH from '@vend/images-ui';
import React, { useMemo } from 'react';
import classNames from 'classnames';
const RESPONSIVE_IMAGE_CLASS = 'vd-util-responsive-img';
const trimInitialAndTrailingSlashes = (relativePath) => {
    return relativePath.replace(/^\/|\/$/g, '');
};
const createAbsolutePath = (relativePath) => {
    return IMAGES_CDN_PATH + trimInitialAndTrailingSlashes(relativePath);
};
const VendImage = ({ alt = '', className, onLoad, relativeImagePath, relativeDarkImagePath, responsive, width, }) => {
    const lightImagePath = createAbsolutePath(relativeImagePath);
    const imgClasses = classNames(className, {
        [RESPONSIVE_IMAGE_CLASS]: responsive,
    });
    const isDarkMode = useMemo(() => {
        var _a, _b;
        const isDarkModeSupported = document.body.classList.contains('vd-theme--use-dark-mode') ||
            document.body.classList.contains('vd-theme--dark');
        const prefersDarkScheme = (_b = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-color-scheme: dark)')) === null || _b === void 0 ? void 0 : _b.matches;
        return isDarkModeSupported && prefersDarkScheme;
    }, []);
    const imagePath = isDarkMode && relativeDarkImagePath
        ? createAbsolutePath(relativeDarkImagePath)
        : lightImagePath;
    return (React.createElement("img", { alt: alt, src: imagePath, className: imgClasses, onLoad: onLoad, width: width }));
};
export { VendImage };
